import {CoreGraphNodeId} from '../../../../../@polygonjs/polygonjs/src/core/graph/CoreGraph';
import {Vector2Like} from '../../../../../@polygonjs/polygonjs/src/types/GlobalTypes';
import {ref, Ref} from '@vue/composition-api';
import {LinkIndex} from '../../../components/panels/common/LinkIndex';
import {isBooleanTrue} from '../../../../../@polygonjs/polygonjs/src/core/Type';

interface Options {
	parentId: CoreGraphNodeId | null;
	position: Vector2Like;
	nodeIds: CoreGraphNodeId[];
	linkIndex: LinkIndex;
	element: HTMLElement;
}

export class EditorNavigationNodeListStoreControllerClass {
	private static _instance: EditorNavigationNodeListStoreControllerClass;
	static instance() {
		return (this._instance = this._instance || new EditorNavigationNodeListStoreControllerClass());
	}

	private constructor() {}

	private _displayed!: Ref<boolean>;
	private _position!: Ref<Vector2Like>;
	private _parentId!: Ref<CoreGraphNodeId | null>;
	private _nodeIds!: Ref<CoreGraphNodeId[]>;
	private _linkIndex!: Ref<LinkIndex>;
	private _element: HTMLElement | undefined;
	init() {
		this._displayed = ref(false);
		this._position = ref({
			x: 0,
			y: 0,
		});
		this._nodeIds = ref([]);
		this._parentId = ref(null);
		this._linkIndex = ref(1);
	}

	// getters
	position(): Vector2Like {
		return this._position.value;
	}
	parentId() {
		return this._parentId.value;
	}
	nodeIds(): CoreGraphNodeId[] {
		return this._nodeIds.value;
	}
	linkIndex() {
		return this._linkIndex.value;
	}
	displayed() {
		return isBooleanTrue(this._displayed.value);
	}

	// mutations
	display(options: Options) {
		this._element = options.element;
		this._displayed.value = true;
		this._parentId.value = options.parentId;
		this._setPosition(options.position);
		this._linkIndex.value = options.linkIndex;
		this._setNodeIds(options.nodeIds);
	}
	toggleDisplay(options: Options) {
		// if we toggle display it from the same element
		// we probably meant to hide it
		if (isBooleanTrue(this._displayed.value) && this._element == options.element) {
			this.close();
		} else {
			this.display(options);
		}
	}
	close() {
		this._element = undefined;
		this._displayed.value = false;
		this._position.value.x = -1000;
		this._position.value.y = -1000;
	}
	private _setPosition(position: Vector2Like): void {
		this._position.value.x = position.x;
		this._position.value.y = position.y;
	}
	private _setNodeIds(nodeIds: CoreGraphNodeId[]): void {
		this._nodeIds.value.splice(0, this._nodeIds.value.length);
		for (let nodeId of nodeIds) {
			this._nodeIds.value.push(nodeId);
		}
	}
}

export const NavigationNodeListController = EditorNavigationNodeListStoreControllerClass.instance();
